// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1828":"ea4a3ff3","2935":"a8e1ab9b","5424":"6267fffe","7526":"5ffa3953"}[chunkId] + ".css";
};